module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor12-662324b58eb9cc1ed223f75472f93b1d.png";